import PersonalDevelopmentLogoImg from "@/assets/personaldevelopment.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const PersonalDevelopmentLogo = (props: Props) => (
  <LogoImage
    imgSrc={PersonalDevelopmentLogoImg}
    alt="Personal Development Logo"
    size="navbar"
    {...props}
  />
);
